import { logAppError } from 'Helpers/logger'
import { type Getter, type Setter } from 'jotai'
import {
  defaultPageState,
  errorUpdater,
  loaderUpdater,
  pageState,
  statusUpdater,
} from 'State/page'
import { searchCategories } from './categories'
import {
  categoriesPagedListAtom,
  categoriesQueryAtom,
  categoryFormState,
  getDefaultCategoryFormState,
  defaultEmptyPagedList,
  defaultModalDeleteCategoryState,
  defaultPagedQuery,
  modalDeleteCategoryState,
} from '../state/state'

export const initPageCallback = async (
  get: Getter,
  set: Setter,
): Promise<void> => {
  set(pageState, loaderUpdater(true))

  try {
    await searchCategories(get, set)
    set(pageState, statusUpdater('ready'))
  } catch (e) {
    console.error('### error', e)

    logAppError({
      Component: 'newCategoriesListPage',
      Method: 'initPageCallback',
      appError: e instanceof Error ? e : undefined,
    })

    set(pageState, errorUpdater)
  }

  set(pageState, loaderUpdater(false))
}

export const resetPageCallback = (_: Getter, set: Setter): void => {
  set(pageState, defaultPageState)
  set(categoriesPagedListAtom, defaultEmptyPagedList)
  set(categoriesQueryAtom, defaultPagedQuery)
  set(modalDeleteCategoryState, defaultModalDeleteCategoryState)
  set(categoryFormState, getDefaultCategoryFormState())
}
